import React from "react";

interface SvgProps extends React.SVGProps<SVGSVGElement> {
  size: "small" | "middle";
}

const DiscountIcon: React.FC<SvgProps> = ({ size, ...props }) => (
  <>
    {size === "small" && (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.66666 6.66663H6.675M1.66666 4.33329L1.66666 8.06205C1.66666 8.46971 1.66666 8.67353 1.71271 8.86534C1.75354 9.03541 1.82088 9.19798 1.91226 9.3471C2.01533 9.51529 2.15946 9.65942 2.44771 9.94767L8.83824 16.3382C9.82828 17.3282 10.3233 17.8233 10.8941 18.0087C11.3962 18.1719 11.9371 18.1719 12.4392 18.0087C13.01 17.8233 13.505 17.3282 14.4951 16.3382L16.3382 14.4951C17.3283 13.505 17.8233 13.01 18.0088 12.4392C18.1719 11.9371 18.1719 11.3962 18.0088 10.8941C17.8233 10.3233 17.3283 9.82824 16.3382 8.8382L9.94771 2.44767C9.65946 2.15942 9.51533 2.0153 9.34714 1.91223C9.19802 1.82084 9.03544 1.7535 8.86538 1.71268C8.67357 1.66663 8.46974 1.66663 8.06209 1.66663L4.33333 1.66663C3.39991 1.66663 2.9332 1.66663 2.57668 1.84828C2.26308 2.00807 2.00811 2.26304 1.84832 2.57664C1.66666 2.93316 1.66666 3.39987 1.66666 4.33329ZM7.08333 6.66663C7.08333 6.89674 6.89678 7.08329 6.66666 7.08329C6.43655 7.08329 6.25 6.89674 6.25 6.66663C6.25 6.43651 6.43655 6.24996 6.66666 6.24996C6.89678 6.24996 7.08333 6.43651 7.08333 6.66663Z"
          stroke="currentColor"
          strokeWidth="1.67"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )}

    {size === "middle" && (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 8H8.01M2 5.2L2 9.67451C2 10.1637 2 10.4083 2.05526 10.6385C2.10425 10.8425 2.18506 11.0376 2.29472 11.2166C2.4184 11.4184 2.59135 11.5914 2.93726 11.9373L10.6059 19.6059C11.7939 20.7939 12.388 21.388 13.0729 21.6105C13.6755 21.8063 14.3245 21.8063 14.927 21.6105C15.612 21.388 16.2061 20.7939 17.3941 19.6059L19.6059 17.3941C20.7939 16.2061 21.388 15.612 21.6105 14.927C21.8063 14.3245 21.8063 13.6755 21.6105 13.0729C21.388 12.388 20.7939 11.7939 19.6059 10.6059L11.9373 2.93726C11.5914 2.59135 11.4184 2.4184 11.2166 2.29472C11.0376 2.18506 10.8425 2.10425 10.6385 2.05526C10.4083 2 10.1637 2 9.67452 2L5.2 2C4.0799 2 3.51984 2 3.09202 2.21799C2.7157 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2ZM8.5 8C8.5 8.27614 8.27614 8.5 8 8.5C7.72386 8.5 7.5 8.27614 7.5 8C7.5 7.72386 7.72386 7.5 8 7.5C8.27614 7.5 8.5 7.72386 8.5 8Z"
          stroke="currentColor"
          strokeWidth="1.67"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )}
  </>
);

export default DiscountIcon;
